export function SettingsPage() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold">设置</h1>
      <p className="mt-2 text-sm text-neutral-500">个人资料 / 团队 / 计费 / 通知 / 集成,后端接入后启用。</p>
    </div>
  );
}
